import React from "react";

import { calculateTotalCost } from "ComparePlans/calculateCost";
import isIntuit from "Intuit/isIntuit";
import PropTypes from "prop-types";
import formatCurrency from "Utils/formatCurrency";

import { Title as Header } from "Cobalt/Header";
import { ContentRow } from "Common/Table";

import type { MedicalPlanPrice } from "Utils/types";

type Props = {
  plans: Array<MedicalPlanPrice>;
};

export default function TotalPremiumRow({ plans }: Props) {
  return (
    <ContentRow
      heading={<Header>Total Cost</Header>}
      cell={(plan) => {
        const totalCost = plan.employee_costs ? calculateTotalCost(plan) : plan.total_cost;
        return (
          <Header>
            {plan.prices_loading ? "$\u2026" : Number.isNaN(totalCost) ? "$ --" : formatCurrency(totalCost, 0)}
            <small>/month</small>
          </Header>
        );
      }}
      items={plans}
    />
  );
}

TotalPremiumRow.propTypes = {
  plans: PropTypes.array.isRequired,
};
